/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanySerieInfo,
    JsonCompanySerieInfoFromJSON,
    JsonCompanySerieInfoFromJSONTyped,
    JsonCompanySerieInfoToJSON,
} from './JsonCompanySerieInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonCompanySerieInfo
 */
export interface ApiResultOfListOfJsonCompanySerieInfo {
    /**
     * 
     * @type {Array<JsonCompanySerieInfo>}
     * @memberof ApiResultOfListOfJsonCompanySerieInfo
     */
    data?: Array<JsonCompanySerieInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanySerieInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonCompanySerieInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanySerieInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanySerieInfo
     */
    result?: ApiResultOfListOfJsonCompanySerieInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonCompanySerieInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonCompanySerieInfoFromJSON(json: any): ApiResultOfListOfJsonCompanySerieInfo {
    return ApiResultOfListOfJsonCompanySerieInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonCompanySerieInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonCompanySerieInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonCompanySerieInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonCompanySerieInfoToJSON(value?: ApiResultOfListOfJsonCompanySerieInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonCompanySerieInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

